{
  "status": {
    "draft": "Чернетка",
    "published": "Опубліковано",
    "archived": "В архіві"
  },
  "submissionStatus": {
    "assigned": "Не розпочато",
    "draft": "У роботі",
    "submitted": "Здано",
    "returned": "Повернено на доопрацювання",
    "graded": "Оцінено"
  },
  "late": "Із запізненням",
  "list": {
    "title": "Домашні завдання",
    "description": "Завдання, які ви задаєте класу та перевіряєте.",
    "searchPlaceholder": "Пошук завдань…",
    "courseFilter": "Курс",
    "classFilter": "Клас",
    "statusFilter": "Статус",
    "anyCourse": "Будь-який курс",
    "anyClass": "Будь-який клас",
    "anyStatus": "Будь-який статус",
    "due": "До {{date}}",
    "noDue": "Без терміну",
    "maxScore": "Максимум балів: {{score}}",
    "empty": {
      "title": "Завдань ще немає",
      "text": "Створіть завдання для класу, додайте зміст і опублікуйте.",
      "filterText": "За обраними фільтрами нічого не знайдено."
    },
    "actions": {
      "edit": "Редагувати",
      "view": "Переглянути",
      "submissions": "Роботи учнів",
      "publish": "Опублікувати",
      "unpublish": "Зняти з публікації",
      "duplicate": "Дублювати",
      "archive": "Архівувати",
      "more": "Інші дії для «{{title}}»",
      "assign": "Призначити класам"
    },
    "published": "Завдання опубліковано",
    "unpublished": "Завдання повернено в чернетки",
    "duplicated": "Завдання продубльовано",
    "archived": "Завдання архівовано",
    "archiveTitle": "Архівувати «{{title}}»?",
    "archiveDescription": "Завдання зникне в учнів і перестане приймати роботи. Уже здані роботи й оцінки залишаться.",
    "unassigned": "Ще не призначено жодному класу"
  },
  "create": {
    "button": "Створити завдання",
    "title": "Нове домашнє завдання",
    "description": "Оберіть клас і максимальний бал — зміст завдання додасте далі.",
    "titleLabel": "Назва",
    "titlePlaceholder": "напр. Дроби — вправи 1–10",
    "noClasses": "Немає активних класів — спершу створіть клас.",
    "maxScoreLabel": "Максимальний бал",
    "dueLabel": "Термін (необовʼязково)",
    "submit": "Створити завдання",
    "success": "Завдання створено",
    "failed": "Не вдалося створити завдання",
    "validation": "Оберіть клас і вкажіть максимальний бал",
    "noTaughtClasses": "Ви поки не ведете жодного активного класу — попросіть адміністратора призначити вас.",
    "classesLabel": "Класи",
    "classesHint": "Паралельні класи мають спільне завдання — позначте всі класи, яким воно призначається. Зазначений нижче термін застосується до кожного; окремо для класу його можна змінити пізніше.",
    "assignFailed": "Завдання створено, але не вдалося призначити: {{classes}}"
  },
  "editor": {
    "title": "Редактор завдання",
    "back": "До списку завдань",
    "submissions": "Роботи учнів",
    "homeworkTitle": "Назва",
    "lesson": "Урок",
    "noLesson": "Без уроку",
    "maxScore": "Максимальний бал",
    "content": "Зміст завдання",
    "save": "Зберегти завдання",
    "saved": "Завдання збережено",
    "saveFailed": "Не вдалося зберегти завдання",
    "unsaved": "Є незбережені зміни",
    "publish": "Опублікувати",
    "unpublish": "Зняти з публікації",
    "duplicate": "Дублювати",
    "archive": "Архівувати",
    "blocksErrors": "Деякі блоки потребують уваги:",
    "leaveTitle": "Відкинути незбережені зміни?",
    "leaveDescription": "Останні правки не збережено — вони будуть втрачені.",
    "leaveConfirm": "Вийти без збереження",
    "readOnly": {
      "title": "Це домашнє завдання можна переглядати, але не редагувати",
      "text": "Воно належить іншому класу. Змінювати чи публікувати його можуть лише адміністратор школи або вчитель того класу."
    },
    "classes": "Призначені класи",
    "noAssignments": "Ще не призначено жодному класу — учні його не бачать.",
    "assignmentDue": "до {{date}}",
    "assignmentNoDue": "без дедлайну",
    "manageClasses": "Керувати класами"
  },
  "review": {
    "title": "Роботи учнів",
    "description": "Роботи, здані до завдання «{{title}}».",
    "back": "Назад до завдання",
    "needsGradingOnly": "Лише ті, що чекають перевірки",
    "empty": "Робіт ще не здавали.",
    "select": "Відкрити роботу учня {{name}}",
    "selected": "Перевіряємо",
    "none": "Оберіть роботу, щоб перевірити її.",
    "textAnswer": "Письмова відповідь",
    "noText": "Письмової відповіді немає.",
    "attachments": "Вкладення",
    "noAttachments": "Вкладень немає.",
    "scoreLabel": "Бали (максимум {{max}})",
    "feedbackLabel": "Коментар",
    "grade": "Оцінити",
    "graded": "Роботу оцінено",
    "return": "Повернути на доопрацювання",
    "returned": "Роботу повернено учневі",
    "returnNeedsFeedback": "Напишіть, що саме потрібно доопрацювати.",
    "failed": "Не вдалося зберегти",
    "score": "{{score}} / {{max}}",
    "notSubmitted": "Ще не здано"
  },
  "pupilList": {
    "title": "Домашні завдання",
    "description": "Завдання з ваших класів.",
    "empty": {
      "title": "Зараз немає домашніх завдань",
      "text": "Тут з’являються домашні завдання, які вчителі задають вашим класам, і те, що ви вже здали."
    },
    "due": "До {{date}}",
    "noDue": "Без терміну",
    "open": "Відкрити"
  },
  "detail": {
    "back": "До списку завдань",
    "due": "Термін: {{date}}",
    "noDue": "Без терміну",
    "maxScore": "Максимум балів: {{score}}",
    "task": "Завдання",
    "yourWork": "Ваша робота",
    "textLabel": "Ваша відповідь",
    "textPlaceholder": "Напишіть відповідь тут",
    "saveDraft": "Зберегти чернетку",
    "savedDraft": "Чернетку збережено",
    "attachments": "Вкладення",
    "addFile": "Додати файл",
    "addImage": "Додати зображення",
    "addVideo": "Додати відео",
    "addAudio": "Додати аудіо",
    "addLink": "Додати посилання",
    "linkLabel": "Посилання (Loom, YouTube, …)",
    "linkPlaceholder": "https://…",
    "linkAdd": "Додати",
    "linkAdded": "Посилання додано",
    "uploading": "Завантаження… {{percent}}%",
    "uploadProgress": "Поступ завантаження",
    "uploaded": "Вкладення додано",
    "removeAttachment": "Видалити вкладення",
    "removed": "Вкладення видалено",
    "submit": "Здати роботу",
    "resubmit": "Здати ще раз",
    "submitTitle": "Здати домашнє завдання?",
    "submitDescription": "Учитель побачить усе, що ви тут додали.",
    "submitted": "Роботу здано",
    "submitFailed": "Не вдалося здати роботу",
    "lockedGraded": "Роботу вже оцінено, тож її заблоковано. Попросіть учителя повернути її, якщо потрібно щось змінити.",
    "returnedNotice": "Учитель попросив доопрацювати роботу",
    "feedback": "Коментар учителя",
    "score": "Бали: {{score}} / {{max}}",
    "lateNotice": "Роботу здано після терміну."
  },
  "validation": {
    "titleRequired": "Вкажіть назву",
    "maxScoreRequired": "Вкажіть максимальний бал"
  },
  "assign": {
    "title": "Призначити класам",
    "description": "Одне завдання — багато класів, у кожного власний термін. Щойно ви призначите опубліковане завдання, учні одразу отримають сповіщення.",
    "classLabel": "Клас",
    "classPlaceholder": "Оберіть клас",
    "noClasses": "Немає класів для призначення — призначати можна лише класам, які ви ведете.",
    "dueAt": "Термін (необовʼязково)",
    "validation": "Спершу оберіть клас.",
    "success": "Завдання призначено",
    "unassigned": "Призначення знято",
    "current": "Наразі призначено",
    "none": "Ще не призначено жодному класу.",
    "due": "до {{date}}",
    "noDue": "без дедлайну",
    "unassign": "Зняти призначення для {{name}}",
    "unassignTitle": "Зняти призначення для {{name}}?",
    "unassignDescription": "Клас перестане бачити це завдання. Здані роботи та оцінки збережуться.",
    "unassignConfirm": "Зняти",
    "submit": "Призначити"
  },
  "lessonSection": {
    "title": "Домашні завдання до цього уроку",
    "create": "Створити завдання",
    "empty": "До цього уроку ще не привʼязано жодного домашнього завдання."
  }
}
